import { memo } from 'react';
import { WorkerHashrates, WorkerShares } from '~/accountingAndAnonymous/Workers';

type WorkerDetailsProps = {
  workerName: string;
  [x:string]: any;
}

const WorkerDetails = (props: WorkerDetailsProps) => {
  const { workerName, ...workerData } = props;
  return (
    <div className="flex flex-col md:flex-row -mx-3">
    <div className="px-3 py-1 w-full md:w-1/2 mb-6">
      <WorkerHashrates 
        workerName={workerName}
        workerData={workerData}
      />
    </div>
    <div className="px-3 py-1 w-full md:w-1/2 mb-6">
      <WorkerShares 
        workerName={workerName}
        workerData={workerData}
      />
    </div>
  </div>
  );
}

export default memo(WorkerDetails);
